import React from "react";
import { Row, Col, Typography, Input, Popover } from "antd";
import DatePicker from "./datePicker";
import moment from "moment-jalaali";

function TableFilters({ onFilterDate, onFilterSearch, hint }) {
  const { Title } = Typography;
  const { RangePicker } = DatePicker;
  const { Search } = Input;
  return (
    <div style={{ marginBottom: "30px" }}>
      <Title level={5} style={{ color: "grey", marginBottom: "20px" }}>
        فیلترها:
      </Title>
      <Row>
        <Col sm={24} md={12}>
          <Search
            style={{ maxWidth: "280px", marginBottom: "20px" }}
            placeholder="جست و جو"
            onSearch={(phrase) => onFilterSearch(phrase)}
            enterButton
            allowClear
          />
        </Col>
        <Col sm={24} md={12} className="table-filter-rangPicker">
          {hint ? (
            <Popover content={hint}>
              <RangePicker
                placeholder={["از تاریخ", "تا تاریخ"]}
                format="YYYY-MM-DD"
                disabledDate={(current) =>
                  moment("1401/07/01", "jYYYY/jMM/jDD").format("YYYY-M-D") &&
                  current > moment().endOf("day")
                }
                onChange={(dates, dateString) =>
                  onFilterDate(dates, dateString)
                }
              />
            </Popover>
          ) : (
            <RangePicker
              placeholder={["از تاریخ", "تا تاریخ"]}
              format="YYYY-MM-DD"
              disabledDate={(current) =>
                moment("1401/07/01", "jYYYY/jMM/jDD").format("YYYY-M-D") &&
                current > moment().endOf("day")
              }
              onChange={(dates, dateString) => onFilterDate(dates, dateString)}
            />
          )}
        </Col>
      </Row>
    </div>
  );
}

export default TableFilters;
